import { Navigate } from '@sorare/routing';

import { ANY_SPORT_MARKET_COMMON_PACKS } from '@sorare/core/src/constants/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';

const RedirectToCommonPacksPage = () => {
  const { generateSportContextPath } = useSportContext();
  return (
    <Navigate
      to={generateSportContextPath(ANY_SPORT_MARKET_COMMON_PACKS)}
      replace
    />
  );
};
export default RedirectToCommonPacksPage;
